<template>
  <div>
    <el-pageCover
      class="pageBlock"
      :pageMsg="pageMsg"
      @sizeChange="pageSizeChange"
      @currentChange="currentPageChange"
    ></el-pageCover>
    <div class="search-line">
      <el-button type="primary" @click="goToProjectCheck">工程验收</el-button>
      <el-button type="primary" @click="openProjectSelector" plain>切换工程</el-button>
      <div class="search-form-group">
        <label class="group-label">显示周期</label>
        <el-radio-group v-model="period" size="medium" @change="periodChange">
          <el-radio-button label="0">按日</el-radio-button>
          <el-radio-button label="1">按周</el-radio-button>
          <el-radio-button label="2">按月</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <el-dialog title="切换工程" :visible.sync="dialogTableVisible">
      <el-table :data="projList">
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="address" label="工程地址"></el-table-column>
        <el-table-column label="设置" width="150">
          <template slot-scope="scope">
            <span
              class="setProject"
              @click="toActive(scope.row.id)"
              v-if="scope.row.active==0"
            >设为当前工程</span>
            <span class="lookMore" v-if="scope.row.active==1">当前工程</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- <div id="pic"></div> -->
    <!-- <div id="pic1"></div>
    <div id="pic2"></div> -->
    <Chart :processDate="processDate" :timeDate="timeDate" :icvDate="icvDate" :temperatureDate="temperatureDate" :workType="workType"/>
    <Daily :projectId="projectId" />
    <Work :projectId="projectId"  :workType="workType"/>
  </div>
</template>

<script>
import roleMixin from "../../utils/roleMixin";
import mixinList from "../../utils/mixinList";
import Chart from "./part/chart";
import Daily from "./part/daily";
import Work from "./part/work";

import ElPageCover from "../../components/overall/ElPageCover";
import {getEnginList,
        getWorks,
        getWorkSections,
        activeEngin,
        getDateProcess,
        getDateTime,
        getDateIcv,
        getDateTemperature
      } from "../../utils/api";
export default {
  name: "app",
  mixins: [roleMixin, mixinList],
  data() {
    return {
      dialogTableVisible: false,
      period: "0",
      projectId: 0,
      projList: [],
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/engineeringCenter",
        },
        {
          name: "质量管理",
          path: "/transfer/quality",
        },
      ],
      workType:2,
      processDate: {},
      timeDate: {},
      icvDate: {},
      temperatureDate: {},
      search:{
        pageSize: 1000
      }
    };
  },
  computed: {},
  created() {
    this.$store.commit("setArrowList", this.arrowList);
  },
  mounted() {
    this.getProjectList();
    // document.getElementById("pic").appendChild(this.dataURLtoFile(this.$store.state.rn_view.src,`w_${this.workId}_rn_view`))
    // document.getElementById("pic").appendChild(this.$store.state.icv_view)
    // document.getElementById("pic2").appendChild(this.$store.state.tp_view)
  },
  methods: {
    // dataURLtoFile(dataurl, filename) {//将base64转换为文件
    //     var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
    //         bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    //     while(n--){
    //         u8arr[n] = bstr.charCodeAt(n);
    //     }
    //     return new File([u8arr], filename, {type:mime});
    // },
    goToProjectCheck(){
      this.$router.push({path:'/transfer/projectCheck',query:{projectId:this.projectId}});
    },
    getProjectList() {
      let that = this;
      getEnginList(this.search, { listKey: "list" }).then((res) => {
        this.projList = res.data.content.info.list;
        const currentProject = (this.projList || []).find(
          (item) => item.active == 1
        );
        //console.log(currentProject)
        this.projectId = currentProject.id
        this.$store.commit("setProjectId", this.projectId);
        that.$parent.$parent.initRollParameter(that.projectId);
        //获取标段
        getWorkSections({ projectId: currentProject.id }).then((res) => {
          const sections = res.data.content.dataList;
          this.$store.commit("quality/setSections", sections);
        });
        getWorks({projectId: this.projectId}).then((res) => {
          this.workType  = res.data.content.info.list[0].workType;
          //获取 统计数据
          this.getProjectInfo()
        });
      });
    },
    openProjectSelector() {
      this.dialogTableVisible = true;
      // this.getProjectList();
    },
    toActive(setId) {
      let params = {
        id: setId,
      };
      activeEngin(params).then(() => {
        this.getProjectList();
        
      });
    },
    periodChange(){
      //console.log(e)
      this.getProjectInfo()
    },

    //获取工程质量总函数
    getProjectInfo: function(){
      let params = {
        mode: this.period,
        projectId: this.projectId
      }
      
      //console.log(params)
      getDateProcess(params).then(res=> {
        //console.log(res)
        this.processDate = res.data.content.info
      })
      getDateTime(params).then(res=> {
        this.timeDate = res.data.content.info
      })
      getDateIcv(params).then(res=> {
        this.icvDate = res.data.content.info
      })
      getDateTemperature(params).then(res=> {
        this.temperatureDate = res.data.content.info
      })
    }
  },
  components: {
    ElPageCover,
    Chart,
    Daily,
    Work,
  },
};
</script>

<style lang="scss" scoped="">
.search-line {
  background: #ffffff;
  width: 98.5%;
  margin: 0 auto;
  height: 70px;
  padding: 17.5px 17px;
}
.search-line .search-form-group {
  display: inline;
  margin-left: 20px;
}
.search-line .search-form-group .group-label {
  margin-right: 5px;
  font-size: 14px;
}
.setProject {
  display: inline-block;
  font-size: 14px;
  color: #555555;
  background: rgba(238, 236, 236, 1);
  border: 1px solid rgba(196, 196, 196, 1);
  border-radius: 16px;
  padding: 4px 16px;
  cursor: pointer;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
</style>